import { createApi } from '@reduxjs/toolkit/query/react';
import { webApiResponseBaseQuery } from '../state/webApiResponseBaseQuery';

export const boostMailApi = createApi({
  reducerPath: 'boostMailApi',
  baseQuery: webApiResponseBaseQuery,
  endpoints: (builder) => ({
    sendEmail: builder.query<string, { companyBdrId: string; companyName: string }>({
      query: ({ companyBdrId, companyName }) => ({
        url: 'myfx/email/boost',
        method: 'POST',
        body: { companyBdrId, companyName },
      }),
    }),
  }),
});

export const { useLazySendEmailQuery } = boostMailApi;
